import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";
import UserAvatar from "../../../components/mui/material/UserAvatar";
import MentionSpan from "../../../components/MentionSpan";
import { postNotification } from "../../../actions";
var tKey = "wrappers.NotificationToastsDecorator.impl.UserMentionCreatedNotificationToast";
function UserMentionCreatedNotificationToast(props) {
  var notificationId = props.notificationId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var navigate = useNavigate();
  var dispatch = useDispatch();
  var notification = useSelector(function (state) {
    return state.entities.notifications.byId[notificationId];
  });
  var userMentionId = notification.event.objects[0].objectId;
  var userMention = useSelector(function (state) {
    return state.entities.userMentions.byId[userMentionId];
  });
  function handleClick() {
    notification.viewedAt = moment().toISOString();
    dispatch(postNotification(notification));
    toast.dismiss(notificationId);
    navigate("/posts/".concat(userMention.post.id));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center",
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0 me-2"
  }, /*#__PURE__*/React.createElement(UserAvatar, {
    user: userMention.post.user
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex-grow-1"
  }, /*#__PURE__*/React.createElement("div", null, t("".concat(tKey, ".header"), {
    userDisplayableName: userMention.post.user.displayableName
  }), "\xA0\xB7\xA0", moment(notification.createdAt).fromNow(true)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(MentionSpan, {
    sourceLanguageCode: userMention.post.language && userMention.post.language.code,
    linksDisabled: true
  }, userMention.post.text))));
}
export default UserMentionCreatedNotificationToast;
UserMentionCreatedNotificationToast.propTypes = {
  notificationId: PropTypes.number.isRequired
};